<template>
  <div v-if="data?.content" class="description-form-item">
    <div class="content" v-html="data.content"></div>
  </div>
</template>

<script>
export default {
  name: 'Description',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.description-form-item {
  padding: 12px 16px;
}

.content {
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>

<style>
/* Rich text styles for Description content */
.description-form-item .content h1,
.description-form-item .content h2,
.description-form-item .content h3 {
  margin: 0;
  font-weight: 600;
}

.description-form-item .content h1 { font-size: 18px; }
.description-form-item .content h2 { font-size: 16px; }
.description-form-item .content h3 { font-size: 15px; }

.description-form-item .content ul,
.description-form-item .content ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
  counter-reset: item;
}

.description-form-item .content li {
  margin: 0;
  padding-left: 21px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  position: relative;
}

.description-form-item .content ul > li::before {
  content: "• ";
  position: absolute;
  left: 6px;
}

.description-form-item .content ol {
  counter-reset: item;
}

.description-form-item .content ol > li {
  counter-increment: item;
}

.description-form-item .content ol > li::before {
  content: counter(item) ". ";
  position: absolute;
  left: 0;
}

.description-form-item .content strong,
.description-form-item .content b {
  font-weight: 700;
}

.description-form-item .content em,
.description-form-item .content i {
  font-style: italic;
}

.description-form-item .content u {
  text-decoration: underline;
}

.description-form-item .content a {
  color: #004879;
  text-decoration: underline;
}
</style>
